import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.define-property";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { forwardRef } from 'react';
import * as Color from '../../../types/color';
import * as CSS from '../../../types/css';
import * as Element from '../../../types/element';
import * as Shape from '../../../types/shape';
import { alignItems } from '../../../utilities/respondTo';
import { filterForAriaProps } from '../../../utilities/accessibility';
import { getBorder, getMargin, getPadding } from './utils';
import { responsiveConditionalStyle, responsiveStyle, style } from '../../../utilities/css';
import { styled } from '../../../utilities/styled-components';
export var InnerBox = function InnerBox(_a) {
  var dataTag = _a["data-tag"],
      alignContent = _a.alignContent,
      alignItems = _a.alignItems,
      alignSelf = _a.alignSelf,
      b = _a.b,
      backgroundColor = _a.backgroundColor,
      bb = _a.bb,
      bl = _a.bl,
      _b = _a.borderColor,
      borderColor = _b === void 0 ? Color.FunctionalColor.Gray4 : _b,
      borderStrokeWidth = _a.borderStrokeWidth,
      _c = _a.borderStyle,
      borderStyle = _c === void 0 ? CSS.BorderStyle.Solid : _c,
      br = _a.br,
      bt = _a.bt,
      children = _a.children,
      cornerRadius = _a.cornerRadius,
      css = _a.css,
      display = _a.display,
      _d = _a.el,
      el = _d === void 0 ? Element.Box.Div : _d,
      flexBasis = _a.flexBasis,
      flexDirection = _a.flexDirection,
      flexGrow = _a.flexGrow,
      flexShrink = _a.flexShrink,
      flexWrap = _a.flexWrap,
      fluidHeight = _a.fluidHeight,
      fluidWidth = _a.fluidWidth,
      height = _a.height,
      id = _a.id,
      innerRef = _a.innerRef,
      justifyContent = _a.justifyContent,
      m = _a.m,
      maxHeight = _a.maxHeight,
      maxWidth = _a.maxWidth,
      mb = _a.mb,
      mh = _a.mh,
      minHeight = _a.minHeight,
      minWidth = _a.minWidth,
      ml = _a.ml,
      mr = _a.mr,
      mt = _a.mt,
      mv = _a.mv,
      onClick = _a.onClick,
      onMouseEnter = _a.onMouseEnter,
      onMouseLeave = _a.onMouseLeave,
      order = _a.order,
      overflow = _a.overflow,
      p = _a.p,
      pb = _a.pb,
      ph = _a.ph,
      pl = _a.pl,
      position = _a.position,
      pr = _a.pr,
      pt = _a.pt,
      pv = _a.pv,
      textAlign = _a.textAlign,
      verticalAlign = _a.verticalAlign,
      width = _a.width,
      restProps = __rest(_a, ['data-tag', "alignContent", "alignItems", "alignSelf", "b", "backgroundColor", "bb", "bl", "borderColor", "borderStrokeWidth", "borderStyle", "br", "bt", "children", "cornerRadius", "css", "display", "el", "flexBasis", "flexDirection", "flexGrow", "flexShrink", "flexWrap", "fluidHeight", "fluidWidth", "height", "id", "innerRef", "justifyContent", "m", "maxHeight", "maxWidth", "mb", "mh", "minHeight", "minWidth", "ml", "mr", "mt", "mv", "onClick", "onMouseEnter", "onMouseLeave", "order", "overflow", "p", "pb", "ph", "pl", "position", "pr", "pt", "pv", "textAlign", "verticalAlign", "width"]);

  var props = __assign({
    'data-tag': dataTag,
    alignContent: alignContent,
    alignItems: alignItems,
    alignSelf: alignSelf,
    b: b,
    backgroundColor: backgroundColor,
    bb: bb,
    bl: bl,
    borderColor: borderColor,
    borderStrokeWidth: borderStrokeWidth,
    borderStyle: borderStyle,
    br: br,
    bt: bt,
    children: children,
    cornerRadius: cornerRadius,
    css: css,
    displayValue: display,
    flexBasis: flexBasis,
    flexDirection: flexDirection,
    flexGrow: flexGrow,
    flexShrink: flexShrink,
    flexWrap: flexWrap,
    fluidHeight: fluidHeight,
    fluidWidth: fluidWidth,
    height: height,
    id: id,
    justifyContent: justifyContent,
    m: m,
    maxHeight: maxHeight,
    maxWidth: maxWidth,
    mb: mb,
    mh: mh,
    minHeight: minHeight,
    minWidth: minWidth,
    ml: ml,
    mr: mr,
    mt: mt,
    mv: mv,
    onClick: onClick,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    order: order,
    overflow: overflow,
    p: p,
    pb: pb,
    ph: ph,
    pl: pl,
    position: position,
    pr: pr,
    pt: pt,
    pv: pv,
    textAlign: textAlign,
    verticalAlign: verticalAlign,
    width: width
  }, filterForAriaProps(restProps));

  return React.createElement(Div, __assign({
    as: el,
    ref: innerRef
  }, props));
};
var BoxForwardRef = forwardRef(function (props, ref) {
  return React.createElement(InnerBox, __assign({}, props, {
    innerRef: ref
  }));
});
export var Box = Object.assign(BoxForwardRef, {
  displayName: 'Box',
  AlignContent: CSS.AlignContent,
  AlignItems: CSS.AlignItems,
  AlignSelf: CSS.AlignSelf,
  BackgroundColor: Color.AnyColor,
  BorderColor: Color.FunctionalColor,
  BorderStyle: CSS.BorderStyle,
  CornerRadius: Shape.CornerRadius,
  Display: CSS.Display,
  Element: Element.Box,
  FlexDirection: CSS.FlexDirection,
  FlexWrap: CSS.FlexWrap,
  Height: CSS.Height,
  JustifyContent: CSS.JustifyContent,
  MaxHeight: CSS.MaxHeight,
  MaxWidth: CSS.MaxWidth,
  MinHeight: CSS.MinHeight,
  MinWidth: CSS.MinWidth,
  Overflow: CSS.Overflow,
  Position: CSS.Position,
  TextAlign: CSS.TextAlign,
  VerticalAlign: CSS.VerticalAlign,
  Width: CSS.Width
});
var Div = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n    ", "\n    ", ";\n"], ["\n    ", "\n    ", "\n    ", ";\n"])), alignItems, function (props) {
  var alignContent = props.alignContent,
      alignSelf = props.alignSelf,
      backgroundColor = props.backgroundColor,
      cornerRadius = props.cornerRadius,
      displayValue = props.displayValue,
      flexBasis = props.flexBasis,
      flexDirection = props.flexDirection,
      flexGrow = props.flexGrow,
      flexShrink = props.flexShrink,
      flexWrap = props.flexWrap,
      fluidHeight = props.fluidHeight,
      fluidWidth = props.fluidWidth,
      height = props.height,
      justifyContent = props.justifyContent,
      maxHeight = props.maxHeight,
      maxWidth = props.maxWidth,
      minHeight = props.minHeight,
      minWidth = props.minWidth,
      order = props.order,
      overflow = props.overflow,
      position = props.position,
      textAlign = props.textAlign,
      theme = props.theme,
      verticalAlign = props.verticalAlign,
      width = props.width;

  var convertNumberToUnits = function convertNumberToUnits(value) {
    return typeof value === 'number' ? theme.units.getValue(value) : value;
  };

  var s = [];
  s.push(responsiveStyle('alignContent', alignContent, theme), responsiveStyle('alignSelf', alignSelf, theme), responsiveStyle('backgroundColor', backgroundColor, theme, function (c) {
    return String(theme.colors[c] || c);
  }), responsiveStyle('borderRadius', cornerRadius, theme, function (cr) {
    return theme.cornerRadii[cr];
  }), style('boxSizing', 'border-box'), responsiveStyle('display', displayValue, theme), responsiveStyle('flexBasis', flexBasis, theme, function (fb) {
    return typeof fb === 'number' ? theme.units.getValue(fb) : fb;
  }), responsiveStyle('flexDirection', flexDirection, theme), responsiveStyle('flexGrow', flexGrow, theme), responsiveStyle('flexShrink', flexShrink, theme), responsiveStyle('flexWrap', flexWrap, theme), responsiveConditionalStyle('height', fluidHeight, '100%', 'initial', theme), responsiveStyle('height', height, theme, convertNumberToUnits), responsiveStyle('justifyContent', justifyContent, theme), responsiveStyle('maxHeight', maxHeight, theme, convertNumberToUnits), responsiveStyle('maxWidth', maxWidth, theme, convertNumberToUnits), responsiveStyle('minHeight', minHeight, theme, convertNumberToUnits), responsiveStyle('minWidth', minWidth, theme, convertNumberToUnits), responsiveStyle('order', order, theme), responsiveStyle('overflow', overflow, theme), responsiveStyle('position', position, theme), style('transition', theme.transitions["default"]), responsiveStyle('textAlign', textAlign, theme), responsiveStyle('verticalAlign', verticalAlign, theme), responsiveConditionalStyle('width', fluidWidth, '100%', 'initial', theme), responsiveStyle('width', width, theme, convertNumberToUnits), getPadding(props), getMargin(props), getBorder(props));
  return s.join(';\n');
}, function (props) {
  return props.css;
});
var templateObject_1;